import { render, staticRenderFns } from "./email-contato.vue?vue&type=template&id=295eb266"
import script from "./email-contato.vue?vue&type=script&lang=js"
export * from "./email-contato.vue?vue&type=script&lang=js"
import style0 from "./email-contato.vue?vue&type=style&index=0&id=295eb266&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports